import TrackingService from 'services/TrackingService';
import { getCookie, removeCookie } from 'helpers/VanillaCookie';
import HttpService from 'services/HttpService';

export class UpsellBannerPartner {
    constructor() {
        this.http = new HttpService();
        this.cookieName = 'dsp_nfl_game_pass';
        this.pageLoadCount = parseInt(window.localStorage.getItem(this.cookieName)) ?? null;
        this.pageLoadCountToRun = 1;

        // setup tracking service
        this.timeout = 500;
        this.trackingService = new TrackingService(this.timeout);
        this.trackingService.requireFiredStateOnTracking = false

        // elements
        this.banner = document.querySelector('#js-upsell-banner-partner');
        this.close = this.banner?.querySelector('.close');
        this.cta = this.banner?.querySelector('.button');
        this.ctaText = this.cta?.textContent.trim();

        // static vars
        this.showClass = 'show';
        this.animationSpeed = 300;
        this.units = 'px';

        // other vars
        this.lastKnownWindowWidth = null;
        this.lastKnownBannerHeight = null;

        // tracking key values
        this.trackActionObject = {
            ctaText: this.ctaText
        };
    }

    init() {
        if (this.banner) {
            if (this.pageLoadCount === 0) {
                window.localStorage.setItem(this.cookieName, this.pageLoadCount + 1);
            }
            if (getCookie(this.cookieName) && this.pageLoadCount === this.pageLoadCountToRun) {
                this.checkUserState();
            }
        }
    }

    checkUserState() {
        this.http
            .doGet('/xhr/upsell-banner-check/')
            .then((res) => {
                if (res.success) {
                    this.xhrSuccess();
                }
            })
            .catch((err) => {
                // ignore
            });
    }

    xhrSuccess() {
        this.banner.classList.add(this.showClass);
        this.setupResizeHandler();
        this.setupCtaHandler();
        this.setupCloseHandler();
        this.trackView();
        removeCookie(this.cookieName, {
            path: '/'
        });
        window.localStorage.removeItem(this.cookieName);
    }

    // resize

    setupResizeHandler() {
        document.addEventListener('resize', () => {
            this.resizeBanner();
        });
        this.resizeBanner();
    }

    resizeBanner() {
        let winWidth = window.innerWidth;
        if (winWidth !== this.lastKnownWindowWidth) {
            let bannerHeight = this.banner.getBoundingClientRect().height;
            this.lastKnownWindowWidth = winWidth;
            this.lastKnownBannerHeight = bannerHeight;
        }
    }

    // cta

    setupCtaHandler() {
        this.cta.addEventListener('click', (e) => {
            this.trackCta();
        });
    }

    // close

    setupCloseHandler() {
        this.close.addEventListener('click', () => {
            this.trackClose();
            this.hide();
        });
    }

    hide() {
        this.banner.style.bottom = -this.lastKnownBannerHeight + this.units;
        setTimeout(() => {
            this.banner.classList.remove(this.showClass);
        }, this.animationSpeed);
    }

    // tracking calls

    trackView() {
        CBS.Promises.Tracking.onLoad(() => {
            this.trackingService.trackAction('trackGamePassBannerView', this.trackActionObject);
        });
    }

    trackCta() {
        this.trackingService.trackAction('trackGamePassBannerSelect', this.trackActionObject);
    }

    trackClose() {
        this.trackingService.trackAction('trackGamePassBannerCancel', this.trackActionObject);
    }

    // helpers

    isPresent() {
        return this.banner !== null && this.banner.classList.contains(this.showClass);
    }

    getBannerHeight() {
        return this.lastKnownBannerHeight;
    }
}
